export default __webpack_public_path__ + "static/media/gandhi-hall-indore.8765b51d.jpg";